function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 1.48a6.77 6.77 0 100 13.54 6.77 6.77 0 000-13.54zm-8 6.77a8 8 0 1116 0 8 8 0 01-16 0z",
  fill: "#2D2D2D"
});
function SvgCirculovacio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo vacio.svg";
export { SvgCirculovacio as ReactComponent };